import * as types from '../types/categoryTypes';
import { isApiEnabled } from '../../config/env';
import { categoryService } from '../../services/categoryService';
import { modamaiTrace } from '../../utils/modamaiTrace';

export const fetchCategories = () => async (dispatch) => {
  if (!isApiEnabled()) {
    modamaiTrace('fetchCategories skipped (API off)', {});
    return;
  }
  modamaiTrace('fetchCategories START', {});
  dispatch({ type: types.FETCH_CATEGORIES_REQUEST });
  try {
    const tree = await categoryService.getPublicCategories({ tree: 'true' });
    modamaiTrace('fetchCategories OK tree length', {
      roots: Array.isArray(tree) ? tree.length : 'not-array',
    });
    dispatch({ type: types.FETCH_CATEGORIES_SUCCESS, payload: tree });
  } catch (e) {
    const msg = e?.response?.data?.message || e?.message || 'Failed to load categories';
    modamaiTrace('fetchCategories FAILURE', { msg, status: e?.response?.status });
    dispatch({
      type: types.FETCH_CATEGORIES_FAILURE,
      payload: msg,
    });
  }
};
